import * as CONSTANTS from '../../shared/constants';

const { GRID_SIZE } = CONSTANTS;

export const renderExplosions = (ctx, explosions, fireCenterImage, fireLineImage, fireEndImage) => {
  // Render explosions with fire sprites
  if (fireCenterImage && fireLineImage && fireEndImage) {
    // Create a map of explosion positions for quick lookup
    const explosionMap = new Map();
    explosions.forEach(explosion => {
      explosionMap.set(`${explosion.x},${explosion.y}`, explosion);
    });
    
    // Create a set of bomb center positions by looking for explosions that mark themselves as bomb centers
    const bombCenterSet = new Set();
    explosions.forEach(explosion => {
      if (explosion.isBombCenter) {
        bombCenterSet.add(`${explosion.x},${explosion.y}`);
      }
    });
    
    // Render each explosion based on its neighboring explosions
    explosions.forEach(explosion => {
      const x = explosion.x * GRID_SIZE;
      const y = explosion.y * GRID_SIZE;
      
      // Check for neighbors in all 4 directions
      const hasUp = explosionMap.has(`${explosion.x},${explosion.y - 1}`);
      const hasDown = explosionMap.has(`${explosion.x},${explosion.y + 1}`);
      const hasLeft = explosionMap.has(`${explosion.x - 1},${explosion.y}`);
      const hasRight = explosionMap.has(`${explosion.x + 1},${explosion.y}`);
      
      const neighborCount = (hasUp ? 1 : 0) + (hasDown ? 1 : 0) + (hasLeft ? 1 : 0) + (hasRight ? 1 : 0);
      
      // Check if this explosion is at a bomb center position
      const isBombCenter = bombCenterSet.has(`${explosion.x},${explosion.y}`);
      
      // Determine sprite type based on neighbors
      if (isBombCenter || neighborCount >= 3) {
        // Always use center sprite for bomb centers, or for cross/T-junction
        ctx.drawImage(fireCenterImage, x, y, GRID_SIZE, GRID_SIZE);
      } else if (neighborCount === 2) {
        // Check if it's a straight line or corner
        if ((hasUp && hasDown) || (hasLeft && hasRight)) {
          // Straight line - use line sprite
          ctx.save();
          ctx.translate(x + GRID_SIZE/2, y + GRID_SIZE/2);
          if (hasUp && hasDown) ctx.rotate(Math.PI/2); // rotate for vertical
          ctx.drawImage(fireLineImage, -GRID_SIZE/2, -GRID_SIZE/2, GRID_SIZE, GRID_SIZE);
          ctx.restore();
        } else {
          // Corner - use center sprite for now
          ctx.drawImage(fireCenterImage, x, y, GRID_SIZE, GRID_SIZE);
        }
      } else if (neighborCount === 1) {
        // End piece - use end sprite
        ctx.save();
        ctx.translate(x + GRID_SIZE/2, y + GRID_SIZE/2);
        
        if (hasRight) ctx.rotate(0); // pointing right
        else if (hasLeft) ctx.rotate(Math.PI); // pointing left
        else if (hasDown) ctx.rotate(Math.PI/2); // pointing down
        else if (hasUp) ctx.rotate(-Math.PI/2); // pointing up
        
        ctx.drawImage(fireEndImage, -GRID_SIZE/2, -GRID_SIZE/2, GRID_SIZE, GRID_SIZE);
        ctx.restore();
      } else {
        // Isolated explosion - use center sprite
        ctx.drawImage(fireCenterImage, x, y, GRID_SIZE, GRID_SIZE);
      }
    });
  } else {
    // Fallback to simple rendering if sprites not loaded
    explosions.forEach(explosion => {
      ctx.fillStyle = '#ff6b35';
      ctx.fillRect(explosion.x * GRID_SIZE, explosion.y * GRID_SIZE, GRID_SIZE, GRID_SIZE);
    });
  }
};